import { render, staticRenderFns } from "./InsuranceOrderManage.vue?vue&type=template&id=f4b7e32c&scoped=true"
import script from "./InsuranceOrderManage.vue?vue&type=script&lang=js"
export * from "./InsuranceOrderManage.vue?vue&type=script&lang=js"
import style0 from "./InsuranceOrderManage.vue?vue&type=style&index=0&id=f4b7e32c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4b7e32c",
  null
  
)

export default component.exports